import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export function useSearchParams() {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const pushSearchParams = (urlSearchParams: URLSearchParams) => {
    history.push({
      search: "?" + urlSearchParams.toString(),
    });
  };

  const replaceSearchParams = (urlSearchParams: URLSearchParams) => {
    history.replace({
      search: "?" + urlSearchParams.toString(),
    });
  };

  return {
    searchParams,
    pushSearchParams,
    replaceSearchParams,
  };
}
